<template>
  <div>
    <table width="100%" cellspacing="0" cellpadding="0">
      <tbody>
        <tr>
          <td colspan="2">
            <div>
              <div style="text-align:right;">
                <!-- <span class="ms-rteForeColor-3 ms-rteFontSize-3">[</span><a href="/SitePages/GrainEntAdd.aspx"
                  target="_blank"><span class="ms-rteForeColor-3 ms-rteFontSize-3">粮食企业用户注册</span></a><span
                  class="ms-rteForeColor-3 ms-rteFontSize-3">]&nbsp;[</span><a href="/SitePages/SeedEntAdd.aspx"
                  target="_blank"><span class="ms-rteForeColor-3 ms-rteFontSize-3">种苗企业用户注册</span></a><span
                  class="ms-rteForeColor-3 ms-rteFontSize-3">]</span> -->
              </div>
            </div>
          </td>
        </tr>
        <tr class="ms-rteTableEvenRow-0">
          <td class="ms-rteTableEvenCol-0">
            <div dir="ltr" style="text-align:left;line-height:30px;padding-right:20px;padding-left:20px;font-size:16px;margin-top:20px">&emsp;&emsp;各位用户：本系统已启用新版网址：<a href="https://swapp.singlewindow.cn/deskserver/sw/deskIndex?menu_id=nseed"
                target="_blank">https://swapp.singlewindow.cn/deskserver/sw/deskIndex?menu_id=nseed </a>。新旧版本功能一致，但数据暂不互通；2026年6月16日后新增或变更的企业信息请在新版本内再次登记。已在旧版系统内申请调入信息的，或是检疫审批单签发日期在2025年12月20日之前的，相关流程请在旧版内完成。<br>
            </div>
            <em> </em>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "index",
  data () {
    return {
      orgList: []
    }
  },
  async mounted () {
  },
  methods: {
  }
};
</script>

<style scoped >
.ts_lineH >>> .el-form-item__label {
  line-height: 36px;
}
.el-date-editor .el-range__icon {
  font-size: 17px;

  line-height: 28px;
}
.el-radio-button__orig-radio:checked + .el-radio-button__inner {
  color: #fff;
  background-color: #3377ff;
  border-color: #3377ff;
}
td,
tr,
th {
  font-size: 13px;
}
.el-button + .el-button {
  margin-left: 0;
}
td .el-button--mini {
  padding: 5px 7px;
  border-radius: 24px;
}
.el-table th > .cell {
  padding-left: 3px;
  padding-right: 3px;
}
.el-radio-button:last-child .el-radio-button__inner {
  border-radius: 0 20px 20px 0 !important;
}
.el-radio-button:first-child .el-radio-button__inner {
  border-radius: 20px 0 0 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/index/mainIndex.vue